import { ButtonIcon, cn, DecorativeIcon } from "@netlify/ui";
import { parseProps } from "./helpers";
import { alertCN, contentsCN, dismissButtonCN, iconCN } from "./styles";
import type { AlertMessage, AlertProps } from "./types";

export const AlertContents = ({
  as: Component = "div",
  id,
  children,
  className,
}: {
  as?: React.ElementType;
  id?: string;
  children: AlertMessage;
  className?: string;
}) => {
  return (
    <Component id={id} className={cn("alert-markdown", className)}>
      {children}
    </Component>
  );
};

const Alert = ({
  title,
  onDismiss,
  outset,
  className,
  iconClassName,
  ...rest
}: AlertProps) => {
  const { message, role, state, icon } = parseProps(rest);

  if (!message) {
    return null;
  }

  return (
    <div
      id={rest.id}
      className={alertCN({ outset, state, className })}
      role={role}
    >
      <DecorativeIcon
        name={icon}
        className={iconCN({ state, iconClassName })}
      />
      <AlertContents className={contentsCN}>{message}</AlertContents>
      {onDismiss && (
        <ButtonIcon
          iconWrapperClassName="tw-right-0"
          level="tertiary"
          onClick={() => {
            onDismiss();
          }}
          className={dismissButtonCN}
          width={24}
          iconName="close"
          title={["Close", title].filter(Boolean).join(": ")}
        />
      )}
    </div>
  );
};

export default Alert;
